import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Utskrift from "../Utskrift";
import {
  getIleggelseQueryParameters,
  getIleggelseTableRows,
} from "../../../selectors/ileggelserSelector";
import { handleChangeAll as handleChangeAllAction } from "../../../actions/handleChangeAction";
import { getIleggelser as getIleggelserAction } from "../../../actions/ileggelserActions";
import * as title from "../../../constants/titles";

const ileggelseTableHeaders = [
  "Ilegg.nr.",
  "Ilegg.dato",
  "Klokkeslett",
  "Tjenestenr.",
  "Overt.kode",
  "Kj.merke",
  "Nasjon",
  "Gatenavn",
  "Gatenr.",
  "Ved",
  "Ved nr.",
  "Bydel",
  "Ileggelsestype",
  "Bilde",
];

export default function UtskriftContainer() {
  const dispatch = useDispatch();
  const ileggelseTableRows = useSelector(getIleggelseTableRows);
  const queryParameters = useSelector(getIleggelseQueryParameters);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = title.ileggelse.ileggelsesoversikt;
    const sessionStoragePrintData = JSON.parse(
      window.sessionStorage.getItem("printData"),
    );
    dispatch(
      handleChangeAllAction(
        "ILEGGELSER_OVERSIKT_FILTER_FORM",
        sessionStoragePrintData.queryData,
      ),
    );
    dispatch(
      getIleggelserAction(
        sessionStoragePrintData.queryData,
        sessionStoragePrintData.paginationData.page,
        sessionStoragePrintData.paginationData.count,
      ),
    ).then(() => {
      setTimeout(() => {
        window.print();
        window.close();
      }, 1000);
    });

    return () => {
      window.sessionStorage.removeItem("printData");
    };
  }, []);

  return (
    <Utskrift
      title="Ileggelsesoversikt"
      ileggelseTableHeaders={ileggelseTableHeaders}
      ileggelseTableRows={ileggelseTableRows}
      queryParameters={queryParameters}
    />
  );
}
